<div>
  <!-- Titolo e descrizione ora li mostra l'header della sotto-sezione nel genitore (event-detail) -->
  <div class="contract-header">
    <div>
      {{ "riepilogo.contract_custom" | translate }}
    </div>
  </div>

  <p class="contract-tab-all-note">
    <span class="contract-mark">●</span> {{ "riepilogo.contract_tab_all_note" | translate }}
  </p>

  <div *ngIf="canSee('contract')">
    <ol class="contract-steps">
      <li
        *ngFor="let step of steps; let i = index"
        class="contract-step"
        [class.done]="i < stepIndex"
        [class.current]="i === stepIndex"
      >
        <span class="contract-step-dot">
          <app-icon *ngIf="i < stepIndex" name="check" [size]="12"></app-icon>
          <ng-container *ngIf="i >= stepIndex">{{ i + 1 }}</ng-container>
        </span>
        <span class="contract-step-label">{{ step | translate }}</span>
      </li>
    </ol>

    <div class="contract-next">
      <p class="contract-next-text">{{ "riepilogo.contract_stage." + stage | translate: stageHintParams }}</p>
      <ng-container [ngSwitch]="stage">
        <button *ngSwitchCase="'draft'" class="btn-gold contract-primary" (click)="generaContratto()">
          <app-icon name="sparkle" [size]="16"></app-icon>
          {{ "riepilogo.generate_contract" | translate }}
        </button>
        <button *ngSwitchCase="'ready'" class="btn-gold contract-primary" (click)="sendForSignature()">
          <app-icon name="send" [size]="16"></app-icon>
          {{ "riepilogo.send_for_signature" | translate }}
        </button>
        <ng-container *ngSwitchCase="'sent'">
          <button class="btn-gold contract-primary" (click)="shareSignatureLink()">
            <app-icon name="share" [size]="16"></app-icon>
            {{ "riepilogo.share_signature_link" | translate }}
          </button>
          <button type="button" class="contract-text-btn" (click)="sendForSignature()">
            {{ "riepilogo.regenerate_signature_link" | translate }}
          </button>
        </ng-container>
        <button *ngSwitchCase="'signed'" class="btn-gold contract-primary" (click)="generaPdfFirmato()">
          <app-icon name="file" [size]="16"></app-icon>
          {{ "riepilogo.generate_signed_pdf" | translate }}
        </button>
      </ng-container>
    </div>

    <div *ngIf="hasContract" class="contract-present">
      <div class="contract-info">
        <span class="contract-name">
          {{ matrimonio?.event?.contract?.name || ("riepilogo.contract_section" | translate) }}
        </span>
        <span class="contract-date">
          {{ matrimonio?.event?.contract?.dateOfContract | date: "dd/MM/yyyy" }}
        </span>
        <span class="signed-contract-badge" *ngIf="matrimonio?.event?.contract?.is_signed">
          {{ "riepilogo.signed_badge" | translate }}
        </span>
      </div>

      <div class="contract-actions">
        <button class="btn-outline contract-action" (click)="visualizzaContratto()">
          <app-icon name="eye" [size]="15"></app-icon>
          {{ "riepilogo.view" | translate }}
        </button>
        <button class="btn-outline contract-action" (click)="scaricaContratto()">
          <app-icon name="download" [size]="15"></app-icon>
          {{ "riepilogo.download" | translate }}
        </button>
        <button *ngIf="editMode" class="btn-rose contract-action" (click)="generaContratto()">
          {{ "riepilogo.regenerate" | translate }}
        </button>
      </div>

      <div class="contract-history">
        <button class="btn-history-toggle" (click)="loadContractVersions(); showHistory = !showHistory">
          {{ showHistory ? ("riepilogo.hide_history" | translate) : ("riepilogo.show_history" | translate) }}
          <span class="history-count" *ngIf="contractVersions.length > 0">
            {{ contractVersions.length }}
          </span>
        </button>

        <div class="history-list" *ngIf="showHistory">
          <p class="history-empty" *ngIf="contractVersions.length === 0 && contractVersionsLoaded">
            {{ "riepilogo.no_history" | translate }}
          </p>
          <div *ngFor="let v of contractVersions" class="history-item">
            <div class="history-meta">
              <span class="history-label">{{ v.label }}</span>
              <span class="signed-contract-badge" *ngIf="v.is_signed">{{ "riepilogo.signed_badge" | translate }}</span>
              <span class="history-date">{{ v.generated_at | date: "dd/MM/yyyy HH:mm" }}</span>
            </div>
            <button class="btn-outline history-download" (click)="scaricaVersione(v.file)">
              ↓ {{ "riepilogo.download" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="editMode" class="info-box" style="margin-top: 1rem">
        <div class="info">
          <label>{{ "riepilogo.contract_name_label" | translate }}</label>
          <input type="text" [(ngModel)]="matrimonio.event.contract.name" />
        </div>
        <div class="info">
          <label>{{ "riepilogo.contract_date_label" | translate }}</label>
          <input type="date" [(ngModel)]="matrimonio.event.contract.dateOfContract" />
        </div>
      </div>
    </div>
  </div>

  <!-- ── DATI CONTRATTO (stesso form di Impostazioni → Contratto, override per evento) ── -->
  <button type="button" class="contract-custom-toggle" (click)="toggleCustom()" [attr.aria-expanded]="customOpen">
    <span>
      <app-icon name="edit" [size]="15"></app-icon>
      {{ "riepilogo.customize_contract" | translate }}
    </span>
    <span class="contract-custom-chevron" [class.open]="customOpen"><app-icon name="chevron-down" [size]="16"></app-icon></span>
  </button>

  <div *ngIf="customEverOpened" [hidden]="!customOpen">
    <app-contract-settings
      [eventId]="eventId"
      [eventContractOverride]="event?.contract_override ?? null"
      [readOnly]="!editMode"
      [eventTotal]="store.totalAll"
      [eventDeposit]="event?.financial?.deposit ?? null"
      (overrideSaved)="onContractOverrideSaved($event)"
      (depositSaved)="onDepositSaved($event)"
    ></app-contract-settings>
  </div>
</div>

<!-- ANTEPRIMA CONTRATTO -->
<div class="preview-overlay" *ngIf="previewOpen" (click)="closePreview()">
  <div class="preview-container" (click)="$event.stopPropagation()">
    <div class="preview-head">
      <h3 class="preview-title">{{ "riepilogo.preview_title" | translate }}</h3>
      <button class="preview-close" (click)="closePreview()" aria-label="close"><app-icon name="x" [size]="16"></app-icon></button>
    </div>

    <div class="preview-summary">
      <span><strong>{{ clientFullName }}</strong></span>
      <span *ngIf="matrimonio?.event?.date">{{ matrimonio.event.date | date: "dd/MM/yyyy" }}</span>
      <span *ngIf="matrimonio?.event?.location">{{ matrimonio.event.location }}</span>
    </div>

    <iframe class="preview-frame" *ngIf="previewUrl" [src]="previewUrl"></iframe>

    <div class="preview-actions">
      <button class="btn-outline" (click)="closePreview()" [disabled]="finalizing">
        {{ "riepilogo.cancel_preview" | translate }}
      </button>
      <button class="btn-gold" (click)="finalizzaContratto()" [disabled]="finalizing">
        {{ "riepilogo.finalize" | translate }}
      </button>
    </div>
  </div>
</div>
